import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputField from 'components/InputField';
import { Field, reduxForm } from 'redux-form';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Dialog from 'components/Dialog';

class UpdateCustomerDialog extends Dialog {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleSubmit, submitting, onOk } = this.props;

        const show = this.state.show;
        if (this.state.shipping_address === null)
            return (<div />);

        return (

            <Modal backdrop="static" enforceFocus={true} show={show || false} onHide={this.hide}>
                <form onSubmit={handleSubmit(onOk)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Customer Shipping Information</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone{' '} </label>
                                        <Field
                                            className="form-control"
                                            name="phone"
                                            component={InputField}
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="address1">Shipping Street{' '} </label>
                                        <Field
                                            className="form-control"
                                            name="address1"
                                            component={InputField}
                                            type="text"
                                        />


                                    </div>
                                </div>
                                <div className="col-md-4"> <label htmlFor="address1">Apartment, suite, etc.{' '} </label> <Field
                                    className="form-control"
                                    name="address2"
                                    component={InputField}
                                    type="text"
                                /></div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">   <div className="form-group">
                                    <label htmlFor="country">Country{' '} </label>
                                    <Field
                                        className="form-control"
                                        name="country"
                                        component={InputField}
                                        type="text"
                                    />
                                </div> </div>
                                <div className="col-md-4"> <div className="form-group">
                                    <label htmlFor="province">Province{' '} </label>
                                    <Field
                                        className="form-control"
                                        name="province"
                                        component={InputField}
                                        type="text"
                                    />
                                </div></div>
                                <div className="col-md-4">  <div className="form-group">
                                    <label htmlFor="province_code">Province Code{' '} </label>
                                    <Field
                                        className="form-control"
                                        name="province_code"
                                        component={InputField}
                                        type="text"
                                    />
                                </div>      </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">  <div className="form-group">
                                    <label htmlFor="city">City{' '} </label>
                                    <Field
                                        className="form-control"
                                        name="city"
                                        component={InputField}
                                        type="text"
                                    />
                                </div> </div>
                                <div className="col-md-4"><div className="form-group">
                                    <label htmlFor="zip">Zip{' '} </label>
                                    <Field
                                        className="form-control"
                                        name="zip"
                                        component={InputField}
                                        type="text"
                                    />
                                </div>  </div>
                                <div className="col-md-4"></div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button type="button" onClick={this.hide}>Cancel</Button>
                        <Button type="submit" disabled={submitting} bsStyle="success"><i className="fa fa-check"></i>&nbsp;Save Changes</Button>

                    </Modal.Footer>

                </form>
            </Modal>

        );
    }

}

export default reduxForm({ form: "UpdateCustomerDialog" })(UpdateCustomerDialog);


// WEBPACK FOOTER //
// app/components/dashboard/UpdateCustomerDialog.jsx